import { FluVaccineModule } from './pages/flu-vaccine/flu-vaccine.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { Http, HttpModule, JsonpModule, BrowserXhr } from '@angular/http';
import { Error404Component } from './pages/error/404.component';
import { AppComponent } from './app.component';
import { MatCheckboxModule, MatDatepickerModule, MatInputModule, MatRadioModule,
MatButtonModule, MatDialogModule, MatCardModule, MatProgressSpinnerModule } from '@angular/material';
import { DatePickerModule } from './components/date-picker/date-picker.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Utility } from './common/utility';

import { AppRoutingModule } from './routes/app.routing.module';
import { PendingChangesGuard } from './pending-changes.guard';
// Lazy Module
import { RegisterModule } from './pages/register/register.module';
import { RequestAppointmentModule } from './pages/request-appointment/request-appointment.module';

// components
import { LayoutComponent } from './components/layout/layout.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { ScheduleModule } from 'primeng/primeng';
import { DialogComponent } from './components/dialog/dialog.component';
import { AuthHelper } from './common/auth.helper';

// services
import { SpinnerService } from './components/spinner/spinner.service';
import { DialogService } from './shared/services/dialog.service';
import { BaseService } from './shared/services/base.service';
import { ShareService } from './shared/services/share.service';
import { PermissionService } from './shared/services/permission.service';

import { DataTablesModule } from 'angular-datatables';
import { ViewScheduleModule } from './pages/view-schedule/view-schedule.module';
import { ChangePassModule } from './pages/change-password/change-password.module';
import { CreatePassModule } from './pages/create-password/create-password.module';

import { LandingComponent } from './pages/landing/landing.component';
import { AuthService } from './shared/services/auth.service';
import { AuthModule} from './pages/auth/auth.module';
import { ActiveLinkComponent } from './pages/active-link/active-link.component';
import { UpdatePatientInforModule } from './pages/update-patient-information/update-patient-information.component.module';

import { SearchPatientModule } from './pages/search-patient/search-patient.module';
import { ViewInvoicesModule } from './pages/view-invoices/view-invoices.module';
import { ViewUploadedDocumentsModule } from './pages/view-uploaded-documents/view-uploaded-documents.module';
import { AddPatientModule } from './pages/add-patient/add-patient.module';
import { AdminVaccineModule } from './pages/admin-vaccine/admin-vaccine.module';
import { VaccinationModule } from './pages/view-schedule/vaccination.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InformationModule } from "./pages/information/information.module";
import { HeaderService } from './components/header/header.service';
import { LoginComponent } from './pages/login/login.component';
import { ViewPrescriptionsModule } from './pages/view-prescriptions/view-prescriptions.module';

@NgModule({
  declarations: [
    AppComponent,
    Error404Component,
    LayoutComponent,
    HeaderComponent,
    MenuComponent,
    SpinnerComponent,
	  DialogComponent,
    LandingComponent,
    ActiveLinkComponent,
    LoginComponent
],
  imports: [
    BrowserModule,
    HttpModule,
    JsonpModule,
    SharedModule,
    AppRoutingModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    DatePickerModule,
    MatDialogModule,
    MatCardModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    RegisterModule,
    RequestAppointmentModule,
    DataTablesModule,
    ScheduleModule,
    ViewScheduleModule,
    VaccinationModule,
    ChangePassModule,
    CreatePassModule,
    AuthModule,
    UpdatePatientInforModule,
    FluVaccineModule,
    SearchPatientModule,
    ViewInvoicesModule,
    ViewPrescriptionsModule,
    ViewUploadedDocumentsModule,
    AddPatientModule,
    AdminVaccineModule,
    InfiniteScrollModule,
    InformationModule
  ],
  providers: [
    Utility,
    SpinnerService,
    DialogService,
    PermissionService,
    AuthHelper,
    AuthService,
    BaseService,
    ShareService,
    PendingChangesGuard,
    HeaderService
   ],
  entryComponents: [DialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/app.module.ts